export class RefAnneeType {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' }
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
}
